/**
 * Utility function that, given any input, if that input is a function
 * execute said function with the following arguments, otherwise returns the input as is
 */

const executer = <R extends any = void, T extends any = any, K extends any = any[]>(
  input: T,
  ...args: K[]
): R => {
  return typeof input === 'function' ? input(...args) : (input as unknown as R);
};

export default executer;
